import React from 'react';
import { HeaderBarLink } from '@axiom/ui';
import { Link, useLocation } from 'react-router';

export const AuthenticatedHeaderMenuItem = ({
  children,
  name,
  target,
  url,
  secondaryMatchSlug,
  overrideSelect,
}: {
  children: React.ReactNode;
  name: string;
  target?: string;
  url: string;
  secondaryMatchSlug?: string; // used for app level child pages
  overrideSelect?: boolean;
}) => {
  const location = useLocation();
  // the zero index is an empty string
  const urlBits = url.split('?')[0]?.split('/');
  const pathnameBits = location.pathname.split('/');
  let matches = pathnameBits[1] === urlBits?.[1];

  if (secondaryMatchSlug) {
    matches = pathnameBits.at(-1) === secondaryMatchSlug;
  } else if (overrideSelect) {
    matches = false;
  }

  return (
    <HeaderBarLink selected={matches} name={name}>
      <Link data-test={`${name}_HEADER_LINK`} to={url} target={target}>
        {children}
      </Link>
    </HeaderBarLink>
  );
};
